import React from 'react'
import { styled, TableContainer as BaseTableContainer } from '@mui/material'
import { Toast as BaseToast, TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Box = styled(({ children, padding, ...props }) => <div {...props}>{children}</div>)`
  padding: ${props => props.padding};
  /* Agregar margen inferior */
  margin-bottom: 20px;
`

export const ContentWrapper = styled('div')`
  align-items: 'flex-end';
  display: flex;
  justify-content: flex-end;
  flex-direction: ${props => props.flexDirection ?? 'unset'};
`

export const DialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`

export const DialogMessage = styled('div')`
  margin: 20px 0 0;
  text-align: left;
  width: 100%;

  & p {
    padding-bottom: 8px;
  }
  & p:last-child {
    padding-bottom: 0;
  }
`

export const Link = styled(({ children, textAlign, textDecoration, ...props }) => <a {...props}>{children}</a>)`
  align-content: baseline;
  color: ${({ color, theme }) => (color === 'primary' ? theme.palette.blue[50] : theme.palette.gray[50])};
  cursor: pointer;
  display: ${props => props.display || 'flex'};
  font-size: 12px;
  font-style: ${props => (props.italic ? 'italic' : 'initial')};
  line-height: 16px;
  text-align: ${props => props.textAlign || 'initial'};
  text-decoration: ${props => props.textDecoration || 'none'};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 0.5rem 0;
  overflow: visible;
`

export const Toast = styled(BaseToast)`
  &.MuiAlert-root {
    .MuiAlert-icon {
      margin-rigth: 10px;
    }
    .MuiAlert-message {
      font-size: 12px;
      padding: 7px 0;
      width: 100%;
    }
  }
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding} !important;
  }
`

export const TableContainer = styled(BaseTableContainer)`
  margin-bottom: 20px;
`
